import React, { Component } from 'react';
import { Link, Redirect, Route, Switch } from 'react-router-dom';
import PropTypes from 'prop-types';
import {
	Badge,
	Breadcrumb,
	BreadcrumbItem,
	Button,
	Card,
	CardBody,
	CardFooter,
	Col,
	Collapse,
	Container,
	Dropdown,
	DropdownItem,
	DropdownMenu,
	DropdownToggle,
	Form,
	Input,
	InputGroup,
	Modal,
	ModalHeader,
	ModalBody,
	ModalFooter,
	Nav,
	Navbar,
	NavbarBrand,
	NavbarToggler,
	NavItem,
	NavLink,
	Row,
	Tooltip,
	UncontrolledAlert,
	UncontrolledTooltip
} from 'reactstrap';

import AdminAccountRoute from './routes/AdminAccountRoute';
import AdminDashboardRoute from './routes/AdminDashboardRoute';
import AdminCustomerFormsRoute from './routes/AdminCustomerFormsRoute';
import AdminSettingsRoute from './routes/AdminSettingsRoute';

const bodyClass = "fixed-nav ";
const styleHandCursor = {cursor: "pointer"};

class AdminControlPanel extends Component {
	constructor(props) {
		super(props);

		this.state = {
			isCollapseComponentsOpen: false,
			isNavbarResponsiveOpen: false,
			isSideNavOpen: true,
			loginAlert: true,
			modalLogout: false
		}
	}

	handleLoginAlert = () => {
		this.setState({ loginAlert: false });
	};

	toggleDropdownAlerts = () => {
		this.setState({ dropdownAlertsOpen: !this.state.dropdownAlertsOpen });
	};

	toggleComponentsCollapse = () => {
		this.setState({ isCollapseComponentsOpen: !this.state.isCollapseComponentsOpen }, () => {
			if (this.state.isCollapseComponentsOpen && !this.state.isSideNavOpen) {
				this.toggleSideNav();
			}
		});
	};

	toggleModalLogout = () => {
		this.setState({ modalLogout: !this.state.modalLogout });
	};

	toggleNavCollapse = () => {
		this.setState({ isNavbarResponsiveOpen: !this.state.isNavbarResponsiveOpen });
	};
	// close components if sidenav is closed
	toggleSideNav = () => {
		this.setState({ isSideNavOpen: !this.state.isSideNavOpen }, () => {
			document.body.className = (!this.state.isSideNavOpen) ? bodyClass + "sidenav-toggled" : bodyClass;
			if (!this.state.isSideNavOpen && this.state.isCollapseComponentsOpen) {
				this.toggleComponentsCollapse();
			}
		});
	};

	componentWillMount() {
		document.body.className = bodyClass;
		document.body.style = {display: "flex", minHeight: "56vh", flexDirection: "column"};
	}

	componentWillUnmount() {
		document.body.className = undefined;
		document.body.style = undefined;
	}

	render() {
		return (
			<div className="fixed-nav sticky-footer bg-dark">
				<Navbar dark fixed="top" role="navigation" className="bg-dark navbar-expand-lg" id="mainNav">
					<Link to='/admin/cp' className='navbar-brand'>Ecofresh Admin CP</Link>
					<NavbarToggler onClick={this.toggleNavCollapse} type="button" data-toggle="collapse" data-target="#navbarResponsive" aria-controls="navbarResponsive" aria-expanded="false" aria-label="Toggle navigation" />
					<Collapse isOpen={this.state.isNavbarResponsiveOpen} navbar id="navbarResponsive">
						<Nav tag="ul" className="navbar-sidenav" id="exampleAccordion">
							<NavItem tag="li" data-toggle="tooltip" data-placement="right" title="Dashboard" id="tooltipDashboard" style={styleHandCursor}>
								<Link to='/admin/cp' className='nav-link'>
									<i className="fa fa-fw fa-dashboard"></i>{' '}
									<span className="nav-link-text">Dashboard</span>
								</Link>
							</NavItem>
							<NavItem tag="li" data-toggle="tooltip" data-placement="right" title="Account" id="tooltipAccount" style={styleHandCursor}>
								<Link to='/admin/cp/account' className='nav-link'>
									<i className="fa fa-fw fa-user"></i>{' '}
									<span className="nav-link-text">Account</span>
								</Link>
							</NavItem>
							<NavItem tag="li" data-toggle="tooltip" data-placement="right" title="Components" id="tooltipComponents" style={styleHandCursor}>
								<NavLink onClick={this.toggleComponentsCollapse} className="nav-link-collapse collapsed" data-toggle="collapse" data-parent="#exampleAccordion">
									<i className="fa fa-fw fa-wrench"></i>{' '}
									<span className="nav-link-text">Components</span>
								</NavLink>
								<Collapse isOpen={this.state.isCollapseComponentsOpen} tag="ul" className="sidenav-second-level" id="collapseComponents">
									<li>
										<a>Component 1</a>
									</li>
									<li>
										<a>Component 2</a>
									</li>
								</Collapse>
							</NavItem>
							<NavItem tag="li" data-toggle="tooltip" data-placement="right" title="Customer Forms" id="tooltipCustomerForms" style={styleHandCursor}>
								<Link to='/admin/cp/customer-forms' className='nav-link'>
									<i className="fa fa-fw fa-address-card"></i>{' '}
									<span className="nav-link-text">Customer Forms</span>
								</Link>
							</NavItem>
							<NavItem tag="li" data-toggle="tooltip" data-placement="right" title="Settings" id="tooltipSettings" style={styleHandCursor}>
								<Link to='/admin/cp/settings' className='nav-link'>
									<i className="fa fa-fw fa-gear"></i>{' '}
									<span className="nav-link-text">Settings</span>
								</Link>
							</NavItem>
							{!this.state.isSideNavOpen && (
								<div>
									<UncontrolledTooltip placement="right" delay={0} target="tooltipDashboard">Dashboard</UncontrolledTooltip>
									<UncontrolledTooltip placement="right" delay={0} target="tooltipAccount">Account</UncontrolledTooltip>
									<UncontrolledTooltip placement="right" delay={0} target="tooltipComponents">Components</UncontrolledTooltip>
									<UncontrolledTooltip placement="right" delay={0} target="tooltipCustomerForms">Customer Forms</UncontrolledTooltip>
									<UncontrolledTooltip placement="right" delay={0} target="tooltipSettings">Settings</UncontrolledTooltip>
								</div>
							)}
						</Nav>
						<Nav tag="ul" className="sidenav-toggler" style={styleHandCursor}>
							<NavItem tag="li">
								<NavLink onClick={this.toggleSideNav} className="text-center" id="sidenavToggler">
									<i className="fa fa-fw fa-angle-left"></i>
								</NavLink>
							</NavItem>
						</Nav>
						<Nav tag="ul" className="navbar-nav ml-auto">
							<Dropdown isOpen={this.state.dropdownAlertsOpen} toggle={this.toggleDropdownAlerts} tag="li" className="nav-item">
								<DropdownToggle onClick={this.toggleDropdownAlerts} nav caret id="alertsDropdown" className="nav-link mr-lg-2" data-toggle="toggleDropdownAlerts" aria-haspopup={true} aria-expanded={this.state.dropdownAlertsOpen}>
									<i className="fa fa-fw fa-bell"></i>
									<span className="d-lg-none">Alerts
										<Badge tag="span" className="badge-pill badge-warning">6 New</Badge>
									</span>
									<span className="indicator text-warning d-none d-lg-block">
										<i className="fa fa-fw fa-circle"></i>
									</span>
								</DropdownToggle>
								<DropdownMenu aria-labelledby="alertsDropdown">
									<DropdownItem header tag="h6">New Alerts:</DropdownItem>
									<DropdownItem divider />
									<DropdownItem>
										<span className="text-success">
											<strong>
												<i className="fa fa-long-arrow-up fa-fw"></i>Status Update
											</strong>
										</span>
										<span className="small float-right text-muted">11:21 AM</span>
										<div className="dropdown-message small">This is an automated server response message. All systems are online.</div>
									</DropdownItem>
									<DropdownItem divider />
									<DropdownItem>
										<span className="text-danger">
											<strong>
												<i className="fa fa-long-arrow-down fa-fw"></i>Status Update
											</strong>
										</span>
										<span className="small float-right text-muted">11:21 AM</span>
										<div className="dropdown-message small">This is an automated server response message. All systems are online.</div>
									</DropdownItem>
									<DropdownItem divider />
									<DropdownItem>
										<span className="text-success">
											<strong>
												<i className="fa fa-long-arrow-up fa-fw"></i>Status Update
											</strong>
										</span>
										<span className="small float-right text-muted">11:21 AM</span>
										<div className="dropdown-message small">This is an automated server response message. All systems are online.</div>
									</DropdownItem>
									<DropdownItem divider />
									<a className="dropdown-item small">View all alerts</a>
								</DropdownMenu>
							</Dropdown>
							<NavItem tag="li">
							<Form inline className="my-2 my-lg-0 mr-lg-2">
								<InputGroup>
									<Input className="form-control" type="text" placeholder="Search for..." />
									<span className="input-group-btn">
										<Button color="primary">
											<i className="fa fa-search"></i>
										</Button>
									</span>
								</InputGroup>
							</Form>
							</NavItem>
							<NavItem tag="li">
								<Link to='/admin/cp/account' className='nav-link'>
									{this.props.user.displayName}
								</Link>
							</NavItem>
							<NavItem tag="li">
								<NavLink onClick={this.toggleModalLogout}>
									<i className="fa fa-fw fa-sign-out"></i>Logout
								</NavLink>
							</NavItem>
						</Nav>
					</Collapse>
				</Navbar>

				<div className="content-wrapper">
					<Container fluid>
						<Switch>
							<Route path='/admin/cp/account' render={ () => <AdminAccountRoute user={this.props.user} /> } />
							<Route path='/admin/cp/customer-forms' render={ () => <AdminCustomerFormsRoute /> } />
							<Route path='/admin/cp/settings' render={ () => <AdminSettingsRoute user={this.props.user} /> } />
							<Route render={ () => <AdminDashboardRoute givenName={this.props.user.givenName} lastLogin={this.props.user.lastLogin} loginAlert={this.state.loginAlert} handleLoginAlert={this.handleLoginAlert}/> } />
						</Switch>
					</Container>

					<a className="scroll-to-top rounded" href="#page-top">
					<i className="fa fa-angle-up"></i>
					</a>
					{/*<!-- Logout Modal-->*/}
					<Modal isOpen={this.state.modalLogout} toggle={this.toggleModalLogout} fade id="exampleModal" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
						<ModalHeader toggle={this.toggleModalLogout} tag="h5" id="exampleModalLabel">Ready to Leave?</ModalHeader>
						<ModalBody>Select "Logout" below if you are ready to end your current session.</ModalBody>
						<ModalFooter>
							<Button color="secondary" onClick={this.toggleModalLogout}>Cancel</Button>
							<Button color="primary" onClick={() => this.props.handleLogout()}>Logout</Button>
						</ModalFooter>
					</Modal>
				</div>
				<footer style={{backgroundColor: "#212529", height: "56px"}}>
					<Container>
						<div className="text-center">
							<small>Copyright © Ecofresh Cleaners 2017</small>
						</div>
					</Container>
				</footer>
			</div>
		);
	}
}

AdminControlPanel.propTypes = {
  handleLogout: PropTypes.func,
  getUser: PropTypes.func
};

export default AdminControlPanel;


// WEBPACK FOOTER //
// ./src/admin-components/AdminControlPanel.js